/* src/app/components/payroll/authorizations/auth-forms/auth-forms.component.css */
.ant-picker {
  width: 100%;
  border-radius: 8px;
  padding: 0 8px;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
::ng-deep nz-input-group > .ant-input {
  height: 30px;
}
.step-header {
  font-weight: bold;
}
.hours-box {
  margin-right: 4px;
}
:host ::ng-deep .ghost-button {
  font-weight: 500 !important;
  height: 2.25rem !important;
}
.unit-input {
  margin-bottom: 8px;
}
.day-inputs {
  margin-right: 4px;
}
:host ::ng-deep .ant-select-selector {
  border-radius: 8px !important;
  padding: 0 8px !important;
}
::ng-deep .ant-input-status-error,
::ng-deep .ant-input:focus,
::ng-deep .ant-select-status-error {
  border-color: #D9D9D9 !important;
  box-shadow: none !important;
  border-radius: 8px !important;
}
::ng-deep .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  border-color: #D9D9D9 !important;
}
/*# sourceMappingURL=auth-forms.component-YDD2SGPZ.css.map */
